import i18n from "i18next";
import { initReactI18next } from "react-i18next";

// 言語jsonファイルのimport
import translation_en from "./en.json";
import translation_ja from "./ja.json";
import translation_zhCN from "./zh-CN.json";
import translation_zhtw from "./zh-tw.json";
import translation_ko from "./ko.json";

const resources = {
    ja: {
      translation: translation_ja
    },
    en: {
      translation: translation_en
    },
    zhCN: {
      translation: translation_zhCN
    },
    zhtw: {
      translation: translation_zhtw
    },
    ko: {
      translation: translation_ko
    }
  };

  i18n
  .use(initReactI18next) // passes i18n down to react-i18next
  .init({
    resources,
    lng: "ja", 
    interpolation: {
      escapeValue: false // react already safes from xss
    }
  });

  export default i18n;